export default "__VITE_ASSET__C1Zg8Hnc__"